import React from 'react';
export function BackgroundEffects() {
  return <div className="fixed inset-0 z-[-1] overflow-hidden pointer-events-none" data-id="element-36">
      {/* Deep space background */}
      <div className="absolute inset-0 bg-mystic-black" data-id="element-37"></div>

      {/* Subtle radial glows */}
      <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[50%] rounded-full bg-mystic-blue-800/20 blur-[120px]" data-id="element-38"></div>
      <div className="absolute top-[40%] right-[-10%] w-[40%] h-[60%] rounded-full bg-mystic-gold/5 blur-[150px]" data-id="element-39"></div>
      <div className="absolute bottom-[-20%] left-[20%] w-[60%] h-[40%] rounded-full bg-mystic-blue-900/30 blur-[120px]" data-id="element-40"></div>

      {/* Noise texture overlay for premium feel */}
      <div className="absolute inset-0 opacity-[0.03] mix-blend-overlay" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} data-id="element-41"></div>
    </div>;
}